import { useAppDispatch, useAppSelector } from '@/lib/store'
import { useCallback } from 'react'
import {
  completeOptimisticUpdate,
  optimisticUpdate,
  rollbackOptimisticUpdate
} from '../middleware/optimistic/optimistic-updates'

export const useOptimisticUpdate = () => {
  const dispatch = useAppDispatch()
  const pendingUpdates = useAppSelector(state => state.optimistic.pending)

  const performOptimisticUpdate = useCallback(async <T>(
    key: string,
    data: T,
    serverAction: () => Promise<any>,
    rollbackData?: T
  ) => {
    // Dispatch optimistic update
    dispatch(optimisticUpdate({
      key,
      data,
      rollbackData
    }))

    try {
      // Perform server action
      const result = await serverAction()

      // Complete the optimistic update
      dispatch(completeOptimisticUpdate(key))

      return result
    } catch (error) {
      // Rollback on failure
      dispatch(rollbackOptimisticUpdate(key))
      throw error
    }
  }, [dispatch])

  const isPending = useCallback((key: string): boolean => {
    return Boolean(pendingUpdates[key])
  }, [pendingUpdates])

  return {
    performOptimisticUpdate,
    isPending,
    pendingUpdates
  }
}
